import React from 'react';
import bag from '../.../../../../../../../../../assets/images/bag.svg';
import { Card, CardBody, Col } from 'reactstrap';

const CustomCard = ({ clientName, country, selected, onClick }) => {
  return (
    <Col sm="6" md="4" lg="4" xl="4" className="cursor-pointer d-inline-block mb-4" onClick={onClick}>
      <Card className={`text-center approval-card m-0 ${selected && 'active-custom-card'}`}>
        <div className={`d-flex justify-content-between align-items-center ${country ? 'p-4' : 'p-4'}`}>
          <img src={bag} style={{ width: '27px' }} />
          <div>
            <p className="fw-semibold fs-18 m-0 text-end">{clientName}</p>
            {country && <p className="fw-light fs-14 m-0 text-end">{country}</p>}
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default CustomCard;
